"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var SimpleExampleIconButton_1 = require("./SimpleExampleIconButton");
var StylingExampleIconButton_1 = require("./StylingExampleIconButton");
var PropertiesIconButton_1 = require("./PropertiesIconButton");
exports.ComponentIconButtonPage = function () { return (React.createElement(common_1.Page, { headerText: "Icon Button" },
    React.createElement(common_1.Paragraph, null, "Icon Button is like FAB, but is small and can be used to secundary actions on the page."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(SimpleExampleIconButton_1.SimpleExampleIconButton, null),
    React.createElement(StylingExampleIconButton_1.StylingExampleIconButton, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesIconButton_1.PropertiesIconButton, null))); };
exports.ComponentIconButtonPage.displayName = 'ComponentIconButtonPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconButtonPage/ComponentIconButtonPage.tsx
// module id = 678
// module chunks = 0